module.exports = __webpack_public_path__ + "static/media/6COPUOS1.b3d384da.jpg";